import React,{FC} from "react";
import { UseTranslationContext } from "./TranslationContext";

import './css/normalize.css';
import './css/webflow.css';
import './css/webflow_carsim.css';
import './css/carsim.css';

export const LanguageSelector:FC=()=>{

  // TRANSLATION CONTEXT
  const{currentLanguage, changeLanguage, getKeyFromKeyId} = UseTranslationContext();

  const handleLanguageSelectChange = (event: any) => {
    var buttonLang = document.getElementById("languageChangeButton");
    if(buttonLang != undefined)
    {
      buttonLang.dataset.lang = event.target.value;
      buttonLang.click();
    }
};

const buttonChangeLanguage = (buttonLg: any) => {
  changeLanguage?.(buttonLg.target.dataset.lang);
};
  
return(
    <>
      {/* LANGUAGE SELECT */}
      <div className="icon text-field-icon no-print langSelectSize">
        <select id="langSelect" className="select-field dropdown w-select no-print" value={currentLanguage} onChange={handleLanguageSelectChange}>
          <option value="fr">{getKeyFromKeyId('LANG_FR')}</option>
          <option value="nl">{getKeyFromKeyId('LANG_NL')}</option>
          <option value="en">{getKeyFromKeyId('LANG_EN')}</option>
        </select>
      </div>

      <button id="languageChangeButton" style={{display:'none'}} data-lang="fr" onClick={(d) => buttonChangeLanguage(d)}></button>
  </>
);
}